import Transformer from '../transformer'

export default class AllocationFilesTransformer extends Transformer {
  static fetch(files) {
    return {
      customerId: files.customer.customer_id,
      customerName: files.customer.customer_name,
      fileId: files.file_type.file_type_id,
      fileName: files.file_type.file_type_name,
      id: files.id,

    }
  }
}



// WEBPACK FOOTER //
// ./src/transformers/Files/allocationFiles.js